// dna_frontend/src/pages/ThanNhanManagement.js
// (*** BẢN FIX CUỐI: Đã đồng bộ chính xác các trạng thái Thu Mẫu với Database ***)

import React, { useState, useEffect, useCallback } from 'react';
import api from '../services/api';
import './LietSiManagement.css'; 

// (*** SỬA ***) Cập nhật đúng theo Database của bạn
const TRANG_THAI_THU_MAU_OPTIONS = [
  { key: 'chua_thu', value: 'Chưa thu' },
  { key: 'da_thu_mau', value: 'Đã thu mẫu' },
  { key: 'da_thu_mau_truoc', value: 'Đã thu mẫu trước (01/7/2025)' }, // (Mới)
  { key: 'sai_thong_tin', value: 'Sai thông tin' },
  { key: 'sai_dien', value: 'Sai diện' }, // (Mới)
  { key: 'khong_co_mat', value: 'Không có mặt' },
  { key: 'khong_thu_mau', value: 'Không thu mẫu' },
];

// --- Modal Component ---
const ThanNhanAdminModal = ({ open, onClose, onSave, thanNhan, xaPhuongList }) => {
    const [formData, setFormData] = useState({ 
        ho_ten: '', nam_sinh: '', cccd: '', dia_chi: '', xa_id: '',
        trang_thai_thu_mau: 'chua_thu', 
        ngay_cap_nhat_thu_mau: '' 
    });
    const [error, setError] = useState('');
    const [isSaving, setIsSaving] = useState(false);

    useEffect(() => {
        if (open && thanNhan) { 
            let formattedDate = '';
            if (thanNhan.ngay_cap_nhat_thu_mau) {
                try {
                    formattedDate = new Date(thanNhan.ngay_cap_nhat_thu_mau).toISOString().split('T')[0];
                } catch (e) {}
            }

            setFormData({
                ho_ten: thanNhan.ho_ten || '',
                nam_sinh: thanNhan.nam_sinh || '',
                cccd: thanNhan.cccd || '', 
                dia_chi: thanNhan.dia_chi || '',
                xa_id: thanNhan.xa_id || '',
                // Nếu dữ liệu cũ không nằm trong list mới, fallback về 'chua_thu'
                trang_thai_thu_mau: thanNhan.trang_thai_thu_mau || 'chua_thu',
                ngay_cap_nhat_thu_mau: formattedDate
            });
            setError('');
        }
    }, [open, thanNhan]);

    const handleChange = (e) => {
        setFormData({ ...formData, [e.target.name]: e.target.value });
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setError('');

        if (!formData.ho_ten || !formData.nam_sinh || !formData.cccd || !formData.dia_chi || !formData.xa_id) {
            setError('Các trường thông tin cá nhân là bắt buộc.');
            return;
        }
        if (!/^\d{4}$/.test(formData.nam_sinh)) {
            setError('Năm sinh phải là 4 chữ số.');
            return;
        }
        if (formData.cccd.length < 3) {
            setError('CCCD phải có ít nhất 3 ký tự.');
            return;
        }

        setIsSaving(true);
        try {
            await api.put(`/than-nhan/admin/${thanNhan.id}`, formData);
            onSave(); 
            onClose(); 
        } catch (err) {
            setError(err.response?.data?.message || 'Lỗi khi lưu');
        } finally {
            setIsSaving(false);
        }
    };

    if (!open) return null;
    
    return (
        <div className="modal-backdrop">
            <div className="modal-content">
                <h3>Sửa thông tin Thân nhân</h3>
                {error && <p className="modal-error">{error}</p>}
                <form onSubmit={handleSubmit}>
                    <div className="form-group">
                        <label htmlFor="modal_ho_ten">Họ tên (*)</label>
                        <input id="modal_ho_ten" type="text" name="ho_ten" value={formData.ho_ten} onChange={handleChange} required />
                    </div>
                    <div className="form-group">
                        <label htmlFor="modal_nam_sinh">Năm sinh (*)</label>
                        <input id="modal_nam_sinh" type="text" name="nam_sinh" value={formData.nam_sinh} onChange={handleChange} maxLength={4} required />
                    </div>
                    <div className="form-group">
                        <label htmlFor="modal_cccd">CCCD (*)</label>
                        <input id="modal_cccd" type="text" name="cccd" value={formData.cccd} onChange={handleChange} required />
                    </div>
                    <div className="form-group">
                        <label htmlFor="modal_dia_chi">Địa chỉ (*)</label>
                        <input id="modal_dia_chi" type="text" name="dia_chi" value={formData.dia_chi} onChange={handleChange} required />
                    </div>
                    <div className="form-group">
                        <label htmlFor="modal_xa_id">Xã/Phường (*)</label>
                        <select id="modal_xa_id" name="xa_id" value={formData.xa_id} onChange={handleChange} required>
                            <option value="">-- Chọn xã --</option>
                            {xaPhuongList.map(xa => (<option key={xa.id} value={xa.id}>{xa.ten_xa}</option>))}
                        </select>
                    </div>
                    
                    <hr style={{margin: '15px 0', border: '0', borderTop: '1px solid #eee'}} />
                    <h4 style={{marginTop: 0, color: '#007bff'}}>Thông tin Thu Mẫu (Admin)</h4>
                    
                    <div className="form-group">
                        <label htmlFor="modal_tt_thu_mau">Trạng thái Thu mẫu</label>
                        <select id="modal_tt_thu_mau" name="trang_thai_thu_mau" value={formData.trang_thai_thu_mau} onChange={handleChange}>
                            {TRANG_THAI_THU_MAU_OPTIONS.map(opt => (
                                <option key={opt.key} value={opt.key}>{opt.value}</option>
                            ))}
                        </select>
                    </div>
                    
                    <div className="form-group">
                        <label htmlFor="modal_ngay_thu">Ngày Thu mẫu / Cập nhật</label>
                        <input id="modal_ngay_thu" type="date" name="ngay_cap_nhat_thu_mau" value={formData.ngay_cap_nhat_thu_mau} onChange={handleChange} />
                        <small style={{color: 'gray'}}>Để trống nếu chưa có ngày cụ thể.</small>
                    </div>

                    <div className="modal-actions">
                        <button type="button" onClick={onClose} className="btn-secondary" disabled={isSaving}>Hủy</button>
                        <button type="submit" className="btn-primary" disabled={isSaving}>{isSaving ? 'Đang lưu...' : 'Lưu'}</button>
                    </div>
                </form>
            </div>
        </div>
    );
};

// --- Component Trang chính ---
function ThanNhanManagement() {
    const [list, setList] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState('');
    
    const [filters, setFilters] = useState({
        ten_tn: '', cccd: '', xa_id: '', is_deleted: 'false', 
        chua_co_nam_sinh: false, trang_thai_tm: '' 
    });
    
    const [currentPage, setCurrentPage] = useState(1);
    const [totalPages, setTotalPages] = useState(0);
    const [xaPhuongList, setXaPhuongList] = useState([]);
    
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [currentThanNhan, setCurrentThanNhan] = useState(null); 

    useEffect(() => {
        const fetchXa = async () => {
            try {
                const res = await api.get('/data/xaphuong');
                setXaPhuongList(res.data);
            } catch (err) { console.error("Lỗi tải danh sách xã", err); }
        };
        fetchXa();
    }, []);

    const fetchData = useCallback(async (page, currentFilters) => {
        setLoading(true);
        setError('');
        try {
            const params = new URLSearchParams({ page: page, limit: 50, ...currentFilters });
            const res = await api.get(`/than-nhan/admin/all?${params.toString()}`);
            setList(res.data.data);
            setTotalPages(res.data.totalPages);
            setCurrentPage(res.data.currentPage);
        } catch (err) { setError('Lỗi tải danh sách thân nhân'); } 
        finally { setLoading(false); }
    }, []);
    
    useEffect(() => { fetchData(1, filters); }, []); 

    const handleFilterChange = (e) => {
        const { name, value, type, checked } = e.target;
        setFilters(prev => ({ ...prev, [name]: type === 'checkbox' ? checked : value }));
    };

    const handleFilterSubmit = (e) => {
        e.preventDefault();
        setCurrentPage(1);
        fetchData(1, filters);
    };

    const handlePageChange = (newPage) => {
        if (newPage >= 1 && newPage <= totalPages) { fetchData(newPage, filters); }
    };
    
    const handleOpenEditModal = (thanNhan) => {
        setCurrentThanNhan(thanNhan); 
        setIsModalOpen(true);
    };
    
    const handleSave = () => { fetchData(currentPage, filters); };

    const handleSoftDelete = async (id, hoTen) => {
        if (window.confirm(`Bạn có chắc muốn XÓA MỀM thân nhân [${hoTen}]?`)) {
            try { await api.delete(`/than-nhan/admin/delete/${id}`); fetchData(currentPage, filters); } 
            catch (err) { setError(err.response?.data?.message || 'Lỗi khi xóa'); }
        }
    };

    const handleRestore = async (id, hoTen) => {
        if (window.confirm(`Bạn có chắc muốn KHÔI PHỤC thân nhân [${hoTen}]?`)) {
            try { await api.put(`/than-nhan/admin/restore/${id}`); fetchData(currentPage, filters); } 
            catch (err) { setError(err.response?.data?.message || 'Lỗi khi khôi phục'); }
        }
    };
    
    return (
        <div className="liet-si-container">
            <h1>Quản lý Thân nhân (Admin)</h1>
            {error && <p className="error-message">{error}</p>}

            <form onSubmit={handleFilterSubmit} className="filter-form">
                <div className="filter-grid" style={{ gridTemplateColumns: 'repeat(4, 1fr)', gap: '10px' }}>
                    <input type="text" name="ten_tn" value={filters.ten_tn} onChange={handleFilterChange} placeholder="Tìm theo tên Thân nhân..."/>
                    <input type="text" name="cccd" value={filters.cccd} onChange={handleFilterChange} placeholder="Tìm theo 3 số cuối CCCD..."/>
                    <select name="xa_id" value={filters.xa_id} onChange={handleFilterChange}>
                        <option value="">-- Lọc theo xã --</option>
                        {xaPhuongList.map(xa => (<option key={xa.id} value={xa.id}>{xa.ten_xa}</option>))}
                    </select>
                    <select name="trang_thai_tm" value={filters.trang_thai_tm} onChange={handleFilterChange}>
                        <option value="">-- Tất cả trạng thái thu mẫu --</option>
                        {TRANG_THAI_THU_MAU_OPTIONS.map(opt => (<option key={opt.key} value={opt.key}>{opt.value}</option>))}
                    </select>
                </div>
                
                <div className="filter-checkbox" style={{ justifyContent: 'space-between' }}>
                    <div>
                        <input type="checkbox" name="chua_co_nam_sinh" id="chua_co_nam_sinh" checked={filters.chua_co_nam_sinh} onChange={handleFilterChange} />
                        <label htmlFor="chua_co_nam_sinh" style={{ color: 'blue', fontWeight: 'bold', marginLeft: '5px' }}>Chỉ hiển thị Thân nhân CHƯA CÓ NĂM SINH</label>
                    </div>
                     <div>
                        <label htmlFor="is_deleted" style={{marginRight: '5px'}}>Trạng thái Xóa: </label>
                        <select name="is_deleted" id="is_deleted" value={filters.is_deleted} onChange={handleFilterChange}>
                            <option value="false">Chưa xóa</option>
                            <option value="true">Đã xóa</option>
                            <option value="">Tất cả (Cả Xóa và Chưa xóa)</option>
                        </select>
                    </div>
                </div>
                
                <div className="filter-actions">
                    <button type="submit" className="btn-primary">Lọc</button>
                    <button type="button" onClick={() => {
                        const emptyFilters = { ten_tn: '', cccd: '', xa_id: '', is_deleted: 'false', chua_co_nam_sinh: false, trang_thai_tm: '' };
                        setFilters(emptyFilters);
                        fetchData(1, emptyFilters);
                    }} className="btn-secondary">Xóa lọc</button>
                </div>
            </form>

            {loading && <p>Đang tải danh sách...</p>}
            
            <div className="table-wrapper">
                <table className="crud-table">
                    <thead>
                        <tr>
                            <th>ID</th>
                            <th>Họ tên</th>
                            <th>Năm sinh</th>
                            <th>CCCD</th>
                            <th>Liệt sĩ liên quan</th>
                            <th>Địa chỉ</th>
                            <th>Xã</th>
                            <th>Trạng thái (Thu mẫu)</th>
                            <th>Ngày thu</th>
                            <th>Hành động</th>
                        </tr>
                    </thead>
                    <tbody>
                        {list.length === 0 && !loading && (
                            <tr><td colSpan="10" style={{textAlign: 'center'}}>Không có dữ liệu.</td></tr>
                        )}
                        {list.map(tn => (
                            <tr key={tn.id} style={{ 
                                background: tn.is_deleted ? '#ffebee' : 'none',
                                textDecoration: tn.is_deleted ? 'line-through' : 'none',
                                color: tn.is_deleted ? '#b71c1c' : 'inherit'
                            }}>
                                <td>{tn.id}</td>
                                <td>{tn.ho_ten}</td>
                                <td style={{ color: !tn.nam_sinh ? 'red' : 'inherit', fontWeight: !tn.nam_sinh ? 'bold' : 'normal' }}>
                                    {tn.nam_sinh || '!! CHƯA CÓ !!'}
                                </td>
                                <td>{tn.cccd}</td>
                                
                                <td style={{ maxWidth: '200px' }}>
                                    {tn.thong_tin_ls ? (
                                        <span style={{color: '#0056b3', fontWeight: '500'}}>{tn.thong_tin_ls}</span>
                                    ) : (
                                        <span style={{color: 'red', fontWeight: 'bold'}}>KHÔNG CÓ LS</span>
                                    )}
                                </td>

                                <td>{tn.dia_chi}</td>
                                <td>{tn.ten_xa}</td>
                                <td style={{ 
                                    color: tn.trang_thai_thu_mau === 'da_thu_mau' || tn.trang_thai_thu_mau === 'da_thu_mau_truoc' ? 'green' : 'gray', 
                                    fontWeight: ['da_thu_mau', 'da_thu_mau_truoc'].includes(tn.trang_thai_thu_mau) ? 'bold' : 'normal' 
                                }}>
                                    {TRANG_THAI_THU_MAU_OPTIONS.find(o => o.key === tn.trang_thai_thu_mau)?.value || tn.trang_thai_thu_mau}
                                </td>
                                <td>{tn.ngay_cap_nhat_thu_mau ? new Date(tn.ngay_cap_nhat_thu_mau).toLocaleDateString('vi-VN') : ''}</td>
                                <td className="actions-cell">
                                    <button onClick={() => handleOpenEditModal(tn)} className="btn-edit" disabled={tn.is_deleted}>
                                        Sửa
                                    </button>
                                    {tn.is_deleted ? (
                                        <button onClick={() => handleRestore(tn.id, tn.ho_ten)} className="btn-success">
                                            Khôi phục
                                        </button>
                                    ) : (
                                        <button onClick={() => handleSoftDelete(tn.id, tn.ho_ten)} className="btn-delete">
                                            Xóa
                                        </button>
                                    )}
                                </td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            </div>
            
            {totalPages > 0 && (
                <div className="pagination">
                    <button onClick={() => handlePageChange(1)} disabled={currentPage === 1}>Trang đầu</button>
                    <button onClick={() => handlePageChange(currentPage - 1)} disabled={currentPage === 1}>Trang trước</button>
                    <span>Trang <strong>{currentPage}</strong> / {totalPages}</span>
                    <button onClick={() => handlePageChange(currentPage + 1)} disabled={currentPage === totalPages}>Trang sau</button>
                    <button onClick={() => handlePageChange(totalPages)} disabled={currentPage === totalPages}>Trang cuối</button>
                </div>
            )}
            
            <ThanNhanAdminModal
                open={isModalOpen}
                onClose={() => setIsModalOpen(false)}
                onSave={handleSave}
                thanNhan={currentThanNhan}
                xaPhuongList={xaPhuongList}
            />
        </div>
    );
}

export default ThanNhanManagement;